import { randomUUID } from '@/shared/lib/uuid';
import { useCallback, useRef } from 'react';

/** Keep one request key for uncertain retries. A changed intent or explicit resend gets a new key. */
export function useCommandKey() {
  const current = useRef<{ fingerprint: string; key: string } | null>(null);
  const reserve = useCallback((intent: unknown) => {
    const fingerprint = JSON.stringify(intent);
    if (current.current?.fingerprint !== fingerprint) {
      current.current = { fingerprint, key: randomUUID() };
    }
    return current.current.key;
  }, []);
  const reset = useCallback(() => {
    current.current = null;
  }, []);
  return { reserve, reset };
}
